import React, { useEffect, useState, useLayoutEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "src/store/actions/action";
import { useSelectUserQuery, useUpdateUserMutation, useExecuteSummaryQuery } from "src/api/userAPI";
import { useSkuRateQuery } from "src/api/skuAPI";
import { getCookie, logoutCookie } from "src/utils/cookieUtil";
import { getPathValue } from "src/utils/queryStringUtil";
import { shallowEqual } from "react-redux";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import IconLink from "src/assets/images/iconLink.svg";
import IconLinkGrey from "src/assets/images/iconLinkGrey.svg";
import Modal, { RefProps } from "src/components/common/Modal";
import styled from "styled-components";
import KakaoMap from "src/components/common/KakaoMap";
import { useLogoutQuery } from "src/api/loginAPI";
import cn from "classnames";
import moment from "moment";
import IcoCate from "src/assets/images/icoCate.svg";
import IcoTel from "src/assets/images/icoTel.svg";
import IcoMap from "src/assets/images/icoMap.svg";
import IcoDate from "src/assets/images/icoDate.svg";
import IcoUser from "src/assets/images/icoUser.svg";
import IcoEmail from "src/assets/images/icoEmail.svg";
import IcoAsed from "src/assets/images/icoAsed.svg";
import IcoNotice from "src/assets/images/icoNotice.svg";
import IcoSku from "src/assets/images/icoSku.svg";
import ErrorParser from "src/utils/jsonParser";
import TextInput from "src/components/common/TextInput";
import Select from "src/components/common/Select";
import { UserVo } from "src/vo/userVo";
import { isEmpty } from "lodash";
import SkuList from "src/components/profile/SkuList";
import NoticeFulfillList from "src/components/profile/NoticeFulfillList";

const example = [
  {
    value: "인테리어",
    name: "인테리어",
  },
  {
    value: "전기",
    name: "전기",
  },
  {
    value: "금속",
    name: "금속",
  },
  {
    value: "로고",
    name: "로고",
  },
  {
    value: "목공",
    name: "목공",
  },
  {
    value: "타일",
    name: "타일",
  },
  {
    value: "영상",
    name: "영상",
  },
  {
    value: "모니터",
    name: "모니터",
  },
  {
    value: "스피커",
    name: "스피커",
  },
];

function profile() {
  // 라이브러리 선언
  const navigate = useNavigate();
  const storeId: any = getPathValue();

  // 초기 값 세팅
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  // const [userProfile, setUserProfile] = useState(userInfo);
  const [userProfile, setUserProfile] = useState<UserVo>({
    address: "",
  });
  const [apiSkip, setApiSkip] = useState(true);
  const [isMind, setIsMind] = useState(storeId === userInfo.user_id ? true : false);

  const [callMap, setCallMap] = useState<boolean>(true);

  const [kakaoMapAddress, setKakaoMapAddress] = useState<string>();

  const [inputs, setInputs] = useState({
    companyType: "",
    mChargeName: "",
    mPhone: "",
    mAddress: "",
    sPhone: "",
    sAddress: "",
    sChargeName: "",
    sOpenDate: "",
  });
  const { companyType, mAddress, mChargeName, mPhone, sAddress, sChargeName, sOpenDate, sPhone } = inputs;

  const [isUpdateCheck, setIsUpdateCheck] = useState<boolean>(false);

  // API 영역
  const storeInfo = useSelectUserQuery(storeId, { skip: storeId === undefined });
  const logout = useLogoutQuery(getCookie("re_token"), { skip: apiSkip });
  const executeSum = useExecuteSummaryQuery({ user_id: storeId }, { skip: userInfo.user_type === "E" && userInfo.user_id === storeId });
  const skuInfo = useSkuRateQuery(
    { shop_code: userProfile.erp_code, brand_code: userProfile.brand },
    {
      skip: userInfo.user_type === "E" && userInfo.user_id === storeId,
    },
  );

  const [updateUser, { isError, isSuccess, isLoading, error }] = useUpdateUserMutation();

  // Hook 영역
  useLayoutEffect(() => {
    if (storeId !== undefined && storeInfo.isSuccess) {
      // 수정
      // if (userInfo.user_type === "E" && (storeInfo.data.data.user_type === "M" || storeInfo.data.data.user_type === "S")) {
      //   setIsMind(false);
      // } else {
      //   setIsMind(true);
      // }
      if (userInfo.user_id === storeInfo.data.data.user_id) {
        setIsMind(true);
      } else {
        setIsMind(false);
      }
      setUserProfile(storeInfo.data.data);
      setInputs({
        ...inputs,
        mAddress: storeInfo.data.data.address,
        mPhone: storeInfo.data.data.phone_number,
        mChargeName: storeInfo.data.data.manager,
        companyType: storeInfo.data.data.company_type,
        sAddress: storeInfo.data.data.address,
        sChargeName: storeInfo.data.data.manager,
        sPhone: storeInfo.data.data.phone_number,
      });
    }
  }, [storeInfo]);

  // useEffect(() => {
  //   console.log("===", storeId, "===", userInfo.user_id);
  //   setIsMind(storeId === userInfo.user_id);
  // }, [userProfile]);
  useEffect(() => {
    if (storeId === undefined) {
      // setIsMind(false);
      setUserProfile(userInfo);
    }
  }, []);

  useEffect(() => {
    if (logout.isSuccess) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage("");
      }
      logoutCookie();
      window.sessionStorage.clear();
      const timer = setTimeout(() => {
        navigate("/");
      }, 200);
      return () => clearTimeout(timer);
    }
    if (logout.isError) {
      const message = ErrorParser(logout.error);
      alert(message);
      // logoutCookie();
    }
  }, [logout]);

  useEffect(() => {
    if (isSuccess) {
      alert("수정완료");
      storeInfo.refetch();
      // setCallMap(true);
    }
    if (isError) {
      const message = ErrorParser(error);
      alert(message);
    }
  }, [isSuccess, isError]);

  // 로그아웃 : 모달 관련
  const logoutModalRef = React.useRef<RefProps>(null);
  const logoutBtn = () => {
    if (logoutModalRef.current) logoutModalRef.current.modalOpen();
  };

  const cancelLogout = () => {
    if (logoutModalRef.current) logoutModalRef.current.modalClose();
  };

  const confirmLogout = () => {
    setApiSkip(false);
  };

  // 헤더 스크롤
  const [isScrollTop, setIsScrollTop] = useState(true);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll); //clean up
    };
  }, [isScrollTop]);

  const handleScroll = useCallback(() => {
    if (window.scrollY >= 50) {
      setIsScrollTop(false);
      return;
    } else {
      setIsScrollTop(true);
      return;
    }
  }, [isScrollTop]);

  const profileUpdate = async () => {
    // 정보 수정 쿼리 필요
    let params: object = {};
    if (userInfo.user_type === "M") {
      setKakaoMapAddress(mAddress);
      params = {
        address: mAddress,
        phone_number: mPhone,
        company_type: isEmpty(companyType) ? "인테리어" : companyType,
        manager: mChargeName,
      };
    } else if (userInfo.user_type === "S") {
      setKakaoMapAddress(sAddress);
      params = {
        address: sAddress,
        phone_number: sPhone,
        manager: sChargeName,
      };
    }
    setCallMap(true);
    await updateUser({ userId: storeId, data: params });
  };

  const onChange = (e: any) => {
    const { value, id } = e.target;
    if (id === "sPhone" || id === "mPhone") {
      const onlyNumber = value.replace(/[^0-9]/g, "");
      setInputs({
        ...inputs,
        [id]: onlyNumber,
      });
    } else {
      setInputs({
        ...inputs,
        [id]: value,
      });
    }
  };

  return (
    <>
      <header className={cn(isScrollTop ? "sub-top" : "")}>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            프로필
          </Button>
        </div>
        {isMind && (
          <div className="btn-box">
            <IconButton btnName="로그아웃" className="logout" onClick={logoutBtn}>
              <SVG name="logout" />
            </IconButton>
          </div>
        )}
      </header>

      <Body type="profile">
        {userProfile && userProfile.user_type !== "E" && !isEmpty(userProfile.address) ? (
          <KakaoMap address={kakaoMapAddress ? kakaoMapAddress : String(userProfile.address)} callMap={callMap} />
        ) : (
          <>
            <NoMap></NoMap>
          </>
        )}
        {/* 매장, 업체인 경우 storeInfo, userInfo 세팅 후 렌더링 */}
        {((isMind && storeInfo.isSuccess) || !isMind) && (
          <>
            <TitleBox>
              <div>
                <p className="name">
                  {userProfile.name}
                  <span>{userProfile.user_id}</span>
                </p>
                {userInfo.user_type !== "E" && userInfo.user_id === userProfile.user_id ? (
                  <>
                    {isUpdateCheck ? (
                      <div>
                        <button type="button" className="edit-btn cancel" onClick={() => setIsUpdateCheck(false)}>
                          취소
                        </button>
                        <button
                          type="button"
                          className="edit-btn"
                          onClick={() => {
                            setIsUpdateCheck(false), profileUpdate();
                          }}
                        >
                          저장
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        className="edit-btn"
                        onClick={() => {
                          setIsUpdateCheck(true), setCallMap(false);
                        }}
                      >
                        수정
                      </button>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </TitleBox>

            {!isUpdateCheck && (
              <ProfileBox>
                {userProfile.company_type && <p className="ico-info category">{userProfile.company_type}</p>}

                {(userProfile.email || userProfile.address) && (
                  <>
                    {userProfile.user_type === "E" ? (
                      <p className="ico-info address email">{userProfile.email}</p>
                    ) : (
                      <p className="ico-info address map">{userProfile.address}</p>
                    )}
                  </>
                )}

                {/* 담당자 */}
                {userProfile.manager && <p className="ico-info person">{userProfile.manager}</p>}

                {userProfile.phone_number && (
                  <p className="ico-info tel">
                    {userProfile.phone_number}
                    <a href={`tel:${userProfile.phone_number}`}>통화</a>
                  </p>
                )}

                {userProfile.user_type === "S" && userProfile.open_date ? (
                  <p className="ico-info info">오픈 {moment(userProfile.open_date).format("YYYY.MM.DD")}</p>
                ) : (
                  ""
                )}

                {/* A/S 이력 : 본사가 매장 프로필 볼때 O, 매장이 본인 매장 프로필 볼때 O */}
                {(userInfo.user_type === "E" && userProfile.user_type === "S") || (userInfo.user_type === "S" && userInfo.user_id === userProfile.user_id) ? (
                  <Link to={"/ased-detail/" + userProfile.user_id}>
                    <p className="ico-info as">
                      <span>A/S 이력</span>
                    </p>
                  </Link>
                ) : (
                  ""
                )}

                {/* 공지이행 이력 : 본사 O, 매장 O, 업체 O */}
                {userProfile.user_type === "S" && (
                  <Link to={"/fulfilled-detail/" + userProfile.user_id} state={executeSum.data}>
                    <p className="ico-info notice">
                      <span>공지이행 이력</span>
                    </p>
                    <NoticeFulfillList data={executeSum.data} />
                  </Link>
                )}

                {/* sku : 본사가 매장 프로필 볼때 O */}
                {userInfo.user_type === "E" &&
                  userProfile.user_type === "S" &&
                  skuInfo.isSuccess &&
                  (skuInfo.data.data.constructor !== Object ? (
                    ""
                  ) : (
                    <Link to={"/sku-detail/" + userProfile.user_id}>
                      <p className="ico-info sku">
                        <span>SKU</span>
                      </p>
                      <SkuList skuData={skuInfo.data.data} />
                    </Link>
                  ))}
              </ProfileBox>
            )}
          </>
        )}

        {isUpdateCheck && (
          <ProfileEditBox>
            {/* 업체 노출 */}
            {userInfo.user_type === "M" && (
              <dl>
                <div>
                  <dt>구분</dt>
                  <dd>
                    <Select size="small" options={example} defaultValue={inputs.companyType} id="companyType" onChange={(e) => onChange(e)} />
                  </dd>
                </div>
                <div>
                  <dt>주소</dt>
                  <dd>
                    <TextInput
                      variant="contained"
                      type="text"
                      value={inputs.mAddress}
                      id="mAddress"
                      name="mProfile01"
                      onChange={(e) => onChange(e)}
                      maxLength={50}
                    />
                  </dd>
                </div>
                <div>
                  <dt>담당</dt>
                  <dd className="short">
                    <TextInput
                      variant="contained"
                      type="text"
                      value={inputs.mChargeName}
                      id="mChargeName"
                      name="mProfile02"
                      onChange={(e) => onChange(e)}
                      maxLength={10}
                    />
                  </dd>
                </div>
                <div>
                  <dt>번호</dt>
                  <dd className="short">
                    <TextInput
                      variant="contained"
                      type="text"
                      pattern="\d*"
                      value={inputs.mPhone}
                      id="mPhone"
                      name="mProfile03"
                      onChange={(e) => onChange(e)}
                      maxLength={11}
                      placeholder="'-' 제외 숫자만 작성"
                    />
                  </dd>
                </div>
              </dl>
            )}

            {/* 매장 노출 */}
            {userInfo.user_type === "S" && (
              <dl>
                <div>
                  <dt>주소</dt>
                  <dd>
                    <TextInput
                      variant="contained"
                      type="text"
                      value={inputs.sAddress}
                      id="sAddress"
                      name="sProfile01"
                      onChange={(e) => onChange(e)}
                      maxLength={50}
                    />
                  </dd>
                </div>
                <div>
                  <dt>번호</dt>
                  <dd className="short">
                    <TextInput
                      variant="contained"
                      type="text"
                      pattern="\d*"
                      value={inputs.sPhone}
                      id="sPhone"
                      name="sProfile02"
                      onChange={(e) => onChange(e)}
                      maxLength={11}
                      placeholder="'-' 제외 숫자만 작성"
                    />
                  </dd>
                </div>
                <div>
                  <dt>담당</dt>
                  <dd className="short">
                    <TextInput
                      variant="contained"
                      type="text"
                      value={inputs.sChargeName}
                      id="sChargeName"
                      name="sProfile03"
                      onChange={(e) => onChange(e)}
                      maxLength={10}
                    />
                  </dd>
                </div>
                {/* <div>
                  <dt>오픈</dt>
                  <dd className="short">
                    <TextInput variant="contained" type="number" id="sProfile03" name="sProfile03" />
                  </dd>
                </div> */}
              </dl>
            )}
          </ProfileEditBox>
        )}

        {/* 본사만 노출 : 알림설정 페이지 이동 */}
        {userProfile.user_type === "E" && (
          <StyledLinkBox>
            <Link to="/home-setting">홈화면 설정</Link>
            <Link to="/alarm-setting">알림 설정</Link>
            {userInfo.user_id == "m1" && <Link to="/block-user">사용자 차단</Link>}
          </StyledLinkBox>
        )}
        {/* //본사만 노출 */}
      </Body>

      <Modal ref={logoutModalRef} leftBtnText="취소" rightBtnText="확인" onClick={() => cancelLogout()} onClick2={() => confirmLogout()}>
        <p>로그아웃 하시겠습니까?</p>
      </Modal>
    </>
  );
}

const NoMap = styled.div`
  padding-top: calc(60px + ${({ theme }) => theme.mobile.notchHeight}px);
`;

const TitleBox = styled.div`
  padding: 30px 15px 0;
  > div {
    padding-bottom: 10px;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    ${({ theme }) => theme.flexBox.flexMixin()}
  }
  .name {
    font-size: 18px;
    font-weight: 700;
    > span {
      padding-left: 8px;
      color: #818181;
      font-family: "Roboto";
      font-size: 14px;
      font-weight: 400;
    }
  }
  .edit-btn {
    border: 0;
    padding: 0 0 0 15px;
    appearance: none;
    background: none;
    color: ${({ theme }) => theme.color.subMain};
    font-size: 14px;
    &.cancel {
      color: ${({ theme }) => theme.color.secondary};
    }
  }
`;

const ProfileBox = styled.div`
  min-height: 104px;
  padding: 0 16px 35px;
  color: ${({ theme }) => theme.color.primary};
  font-size: 14px;
  .ico-info {
    min-height: 24px;
    line-height: 24px;
    padding-left: 32px;
    margin-top: 16px;
    color: ${({ theme }) => theme.color.primary};
    background-position: 0 0;
    background-size: 24px;
    background-repeat: no-repeat;
  }
  .address {
    background-image: url(${IcoMap});
  }
  .email {
    background-image: url(${IcoEmail});
  }
  .tel {
    background-image: url(${IcoTel});
    font-family: "Poppins";
    > a {
      padding-left: 16px;
      color: ${({ theme }) => theme.color.subMain};
    }
  }
  .person {
    background-image: url(${IcoUser});
  }
  .category {
    background-image: url(${IcoCate});
  }
  .info {
    background-image: url(${IcoDate});
    font-family: "Poppins";
  }
  .as {
    background-image: url(${IcoAsed});
    > span {
      padding-right: 24px;
      background: url(${IconLinkGrey}) no-repeat right center;
    }
  }
  .notice {
    background-image: url(${IcoNotice});
    > span {
      padding-right: 24px;
      background: url(${IconLinkGrey}) no-repeat right center;
    }
  }
  .sku {
    background-image: url(${IcoSku});
    > span {
      padding-right: 24px;
      background: url(${IconLinkGrey}) no-repeat right center;
    }
  }
`;

const ProfileEditBox = styled.div`
  padding: 12px 15px 0;
  dl {
    > div {
      ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
      margin-top: 8px;
    }
    dt {
      min-width: 24px;
      margin-right: 8px;
      font-size: 14px;
      font-weight: 500;
    }
    dd {
      flex-grow: 1;
      &.short {
        flex-grow: 0;
        flex-basis: 160px;
      }
    }
  }
`;

const StyledLinkBox = styled.div`
  margin-top: 80px;
  padding: 5px 15px;
  background-color: #f4f4f4;
  > a {
    display: block;
    padding: 20px 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    font-size: 16px;
    font-weight: 700;
    background: url(${IconLink}) no-repeat right center;
    &:last-child {
      border-bottom: none;
    }
  }
`;

export default profile;
